import type { FC } from 'react'

import LibSnackbar from '@mui/material/Snackbar'
import { useActionCreators, useAppSelector } from 'shared/hooks'

import { actions, selectors } from '../slice'
import * as SnackNotification from '../ui/SnackNotification'

const styleToCN = {
	attention: 'snackbar-notification-attention',
	default: 'snackbar-notification'
}

const styleToComponent = {
	attention: SnackNotification.Attention,
	default: SnackNotification.Default
}

export function Snackbar() {
	const { resetSnack } = useActionCreators(actions)

	const style = useAppSelector(selectors.snackStyle)
	const isOpen = useAppSelector(selectors.snackOpen)

	let Component: false | FC = false

	Component = styleToComponent[style]

	return (
		<LibSnackbar
			anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			autoHideDuration={5000}
			className={styleToCN[style]}
			message={isOpen && <Component />}
			onClose={(_, reason) => {
				if (reason !== 'clickaway') {
					return resetSnack()
				}
			}}
			open={isOpen}
		/>
	)
}
